// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fondo que cubre toda la pantalla */
.container-spinner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column; /* spinner arriba, texto abajo */
    justify-content: center;
    align-items: center;
    gap: 15px;
    z-index: 9999;
    
    /* Para modo claro */
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(4px); /* Efecto borroso moderno */
    transition: background-color 0.3s ease;
}

/* Para modo oscuro */
body.dark-mode .container-spinner {
    background-color: rgba(0, 0, 0, 0.7);
}

/* Spinner */
.spinner-circle {
    width: 3.5rem;
    height: 3.5rem;
    border: 5px solid var(--primary-blue);
    border-top-color: transparent; 
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* Texto */
.container-spinner p {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--primary-blue);
    letter-spacing: 0.5px;
}

/* Animación */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Spinner/spinner.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB,EAAE,gCAAgC;IACxD,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;;IAEb,oBAAoB;IACpB,0CAA0C;IAC1C,0BAA0B,EAAE,2BAA2B;IACvD,sCAAsC;AAC1C;;AAEA,qBAAqB;AACrB;IACI,oCAAoC;AACxC;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,6BAA6B;IAC7B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,UAAU;AACV;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA,cAAc;AACd;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Fondo que cubre toda la pantalla */\r\n.container-spinner {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column; /* spinner arriba, texto abajo */\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 15px;\r\n    z-index: 9999;\r\n    \r\n    /* Para modo claro */\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    backdrop-filter: blur(4px); /* Efecto borroso moderno */\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n/* Para modo oscuro */\r\nbody.dark-mode .container-spinner {\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n/* Spinner */\r\n.spinner-circle {\r\n    width: 3.5rem;\r\n    height: 3.5rem;\r\n    border: 5px solid var(--primary-blue);\r\n    border-top-color: transparent; \r\n    border-radius: 50%;\r\n    animation: spin 0.8s linear infinite;\r\n}\r\n\r\n/* Texto */\r\n.container-spinner p {\r\n    margin: 0;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    color: var(--primary-blue);\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n/* Animación */\r\n@keyframes spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
